/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 */

import axios from 'axios';

// let netwrokError = false;
// const setNetwrokError = data => {
//     return (netwrokError = data);
// };

axios.interceptors.response.use(null, error => {
    const expectedErr = error.response && error.response.status >= 400 && error.response.status < 500;

    if (!expectedErr) {
        // logger here
        console.error('Unexpected error:', error);
    }

    // Handle 401 Unauthorized errors (token expired or invalid)
    if (error.response && error.response.status === 401) {
        // Import auth service to clear tokens
        const { AuthService } = require('../../modules/users/services/auth/auth.service');
        const authService = new AuthService();

        // Clear all auth tokens
        authService.removeToken('access-token');
        authService.removeToken('refresh-token');
        authService.removeToken('auth-spay-user');
        authService.removeToken('merchant-id');

        // Redirect to login page (public route in this app is '/')
        if (window.location.pathname !== '/') {
            window.location.href = '/';
        }
    }

    return Promise.reject(error);
});

const fetchJSON = (options = {}) => {
    return axios(options)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            throw error.response;
        });
};

export { fetchJSON };
